import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { ArrowLeft, ArrowLeftRight, Building, User, FileText, Calendar } from "lucide-react";
import "./Transfer.css";

const url = process.env.REACT_APP_BACKEND_URL;

const TransferView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [transfer, setTransfer] = useState(null);

  useEffect(() => {
    fetchTransfer();
  }, [id]);

  const fetchTransfer = async () => {
    try {
      const response = await axios.get(`${url}/api/transfer/${id}`);
      setTransfer(response.data.data);
    } catch (error) {
      toast.error("Failed to fetch transfer details");
      navigate("/ViewTransfer");
    }
  };

  if (!transfer) {
    return <div className="transfer-wrapper">Loading...</div>;
  }

  return (
    <div className="transfer-wrapper">
      <div className="transfer-container">
        <div className="transfer-header">
          <button onClick={() => navigate("/ViewTransfer")} className="back-button">
            <ArrowLeft size={20} /> Back to Transfers
          </button>
          <h2 className="transfer-title">
            <ArrowLeftRight size={24} /> Transfer Details
          </h2>
        </div>

        <div className="transfer-details">
          <div className="detail-card">
            <h3>
              <FileText size={18} /> Transfer Information
            </h3>
            <div className="detail-grid">
              <div className="detail-item">
                <label>Transfer No:</label>
                <span>#{transfer.transfer_no}</span>
              </div>
              <div className="detail-item">
                <label>Transfer Date:</label>
                <span>{new Date(transfer.transfer_date).toLocaleString()}</span>
              </div>
              <div className="detail-item">
                <label>Status:</label>
                <span className={`status-badge status-${transfer.transfer_status}`}>
                  {transfer.transfer_status}
                </span>
              </div>
              <div className="detail-item">
                <label>Transfer Reason:</label>
                <span>{transfer.transfer_reason || "N/A"}</span>
              </div>
            </div>
          </div>

          <div className="detail-card">
            <h3>
              <User size={18} /> Customer Information
            </h3>
            <div className="detail-grid">
              <div className="detail-item">
                <label>Name:</label>
                <span>{transfer.original_customer_id?.fullname}</span>
              </div>
              <div className="detail-item">
                <label>Phone:</label>
                <span>{transfer.original_customer_id?.phone}</span>
              </div>
              <div className="detail-item">
                <label>Email:</label>
                <span>{transfer.original_customer_id?.email}</span>
              </div>
              <div className="detail-item">
                <label>Address:</label>
                <span>{transfer.original_customer_id?.address}</span>
              </div>
            </div>
          </div>

          <div className="detail-card">
            <h3>
              <Building size={18} /> Original Client
            </h3>
            <div className="detail-grid">
              <div className="detail-item">
                <label>Client Name:</label>
                <span>{transfer.original_client_id?.name}</span>
              </div>
              <div className="detail-item">
                <label>Location:</label>
                <span>{transfer.original_client_id?.location}</span>
              </div>
              <div className="detail-item">
                <label>Manager:</label>
                <span>{transfer.original_client_id?.manager_name}</span>
              </div>
              <div className="detail-item">
                <label>Contact:</label>
                <span>{transfer.original_client_id?.manager_contact}</span>
              </div>
            </div>
          </div>

          <div className="detail-card">
            <h3>
              <Building size={18} /> New Client
            </h3>
            <div className="detail-grid">
              <div className="detail-item">
                <label>Client Name:</label>
                <span className="new-client">{transfer.new_client_id?.name}</span>
              </div>
              <div className="detail-item">
                <label>Location:</label>
                <span>{transfer.new_client_id?.location}</span>
              </div>
              <div className="detail-item">
                <label>Manager:</label>
                <span>{transfer.new_client_id?.manager_name}</span>
              </div>
              <div className="detail-item">
                <label>Contact:</label>
                <span>{transfer.new_client_id?.manager_contact}</span>
              </div>
            </div>
          </div>

          <div className="detail-card">
            <h3>
              <Calendar size={18} /> Contract Information
            </h3>
            <div className="detail-grid">
              <div className="detail-item">
                <label>Original Contract:</label>
                <span>#{transfer.original_contract_id?.no}</span>
              </div>
              <div className="detail-item">
                <label>New Contract:</label>
                <span>#{transfer.new_contract_id?.no}</span>
              </div>
              <div className="detail-item">
                <label>New Contract Start:</label>
                <span>{new Date(transfer.new_contract_start).toLocaleDateString()}</span>
              </div>
              <div className="detail-item">
                <label>New Contract End:</label>
                <span>{new Date(transfer.new_contract_end).toLocaleDateString()}</span>
              </div>
            </div>
          </div>

          {transfer.approval_remarks && (
            <div className="detail-card">
              <h3>Approval Remarks</h3>
              <p>{transfer.approval_remarks}</p>
            </div>
          )}

          {transfer.remarks && (
            <div className="detail-card">
              <h3>Additional Remarks</h3>
              <p>{transfer.remarks}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TransferView;